import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import { Container, Grid } from '@mui/material';
import { Constants } from '../endPoints';
import axios from 'axios';

export default function Goldprice() {
  const [goldPrices, setGoldPrices] = useState([]);

  useEffect(() => {
    const fetchGoldPrices = async () => {
      try {
        const response = await axios.get(Constants.listGoldPrices);
        if (response.data.status === 1) {
          setGoldPrices(response.data.data);
        } else {
          console.error('Failed to load gold prices');
        }
      } catch (error) {
        console.error('Error fetching gold prices:', error);
      }
    };

    fetchGoldPrices();
  }, []);

  return (
    <>
      <Breadcumb pagetitle="Gold Price" />
      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold headningfont mb-10 text-center">
            All Karats Per Todays Prices USD (gram)
          </h2>
          <Grid container spacing={1} className="justify-center">
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b text-left text-sm text-gray-900 font-bold bg-[#FBF8F1]">
                      Gold
                    </th>
                    <th className="px-6 py-3 border-b text-left text-sm text-gray-900 font-bold bg-[#FBF8F1]">
                      Price Per Gram
                    </th>
                    <th className="px-6 py-3 border-b text-left text-sm text-gray-900 font-bold bg-[#FBF8F1]">
                      Market
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {goldPrices.length > 0 ? (
                    goldPrices.map((item) => (
                      <tr key={item.id} className="hover:bg-gray-100">
                        <td className="px-6 py-4 border-b text-sm text-gray-900">{item.karat.toUpperCase()}</td>
                        <td className="px-6 py-4 border-b text-sm text-gray-900">${parseFloat(item.price_per_gram).toFixed(2)}</td>
                        <td className="px-6 py-4 border-b text-sm text-gray-900">{item.market}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4 text-sm text-gray-500">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}
